<template>
<span class="is-flex align-center" :class="{
    'flex-column': column === true
  }">
  <icon 
    :icon="count > 0 ? 'exclamation-triangle' : 'check-circle'" 
    :type="count > 0 ? 'fas' : 'far'" 
    :class="{
      'has-text-danger': count > 0,
      'has-text-success': count === 0,
    }"
  />
  <span><span>{{ count }} Problem</span><span v-if="count !== 1">s</span></span>
</span>
</template>
<script>

export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
    column: {
      type: Boolean,
      default: false
    }
  },
}
</script>
